import { clearSavedUserFilter } from '@/clientOnlyUtils/clientUtils';
import { getAuth, signOut } from 'firebase/auth';
import React from 'react';

import { api } from '@/utils/api';

import { useExtensionContext } from '~/components/extension.context';

import { type NextPageWithLayout } from './_app';

const LogoutPage: NextPageWithLayout<{ userTeam: { userId: string; teamId: string } }> = () => {
  const [, { postMessage }] = useExtensionContext();
  const utils = api.useUtils();

  React.useEffect(() => {
    void signOut(getAuth()).then(() => {
      localStorage.removeItem('form');
      clearSavedUserFilter();
      postMessage({ type: 'LOGOUT' });
      // reset() clears cached data entirely, unlike invalidate() which only
      // marks it stale. With staleTime > 0, invalidated data can still be
      // served from cache, causing the login page to see a stale user: null.
      void utils.user.me.reset();
    });
  }, [utils, postMessage]);

  return <div />;
};

LogoutPage.createWAuth = (C, props, authData) => <C userTeam={authData} {...props} />;
LogoutPage.unverified = null;

export default LogoutPage;
